import type { IconProps } from '@shared/icons/types';
import React from 'react';
import { CustomShape } from './CustomShape';

type IconBadgeProps = {
  icon: React.ComponentType<IconProps>;
  shapeType?: 'circle' | 'square' | 'custom-shape';
};

function IconBadge({ icon, shapeType = 'circle' }: IconBadgeProps) {
  const Icon = icon as React.ComponentType<IconProps>;

  if (shapeType === 'custom-shape') {
    return (
      <div className="w-16 h-16 flex items-center justify-center" data-testid="icon-container">
        <CustomShape>{Icon && <Icon className="text-secondary" size="large" />}</CustomShape>
      </div>
    );
  }

  return (
    <div
      className={
        shapeType === 'square'
          ? 'w-10 h-10 bg-accent-green rounded-lg flex items-center justify-center text-secondary'
          : 'rounded-full bg-accent-green w-10 h-10 flex items-center justify-center'
      }
      data-testid="icon-container"
    >
      {Icon && <Icon className={shapeType === 'square' ? '' : 'text-foreground dark:text-foreground-inverse'} size="medium" />}
    </div>
  );
}

export { IconBadge };
